<div
	class="flex flex-col gap-5 place-items-center text-center max-w-500 pt-24 m-auto"
>
	<img src="/assets/images/undraw/undraw_void_3A335B.svg" class="max-w-56" />
	<div class="font-bold">No Forms Available For This Lender</div>
	<div>
		We don't currently offer forms for this lender. Please refer to the
		<a
			class="text-tealGreen-500 hover:text-tealGreen-700 underline"
			target="_blank"
			href="{{ lender?.formsLink ?? '' }}"
			*ngIf="lender?.formsLink; else plainText"
			>lender site</a
		>
		<ng-template #plainText>lender site</ng-template>
		or instructions to access lender forms.
	</div>
</div>
